module.exports = __webpack_public_path__ + "static/img/bg-map2.a0d31b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-map2.png
// module id = rWnF
// module chunks = 0